var App = App || {};

App.PurchaseOffcanvas = (function ($) {
    "use strict";

	function Product(data) {
		data = data || {};
		this.key = ko.observable(data.key || "");
		this.contentType = ko.observable(data.contentType || "");
		this.price = ko.observable(data.price || 0.0);
		this.currency = ko.observable(data.currency || "USD");
		this.title = ko.observable(data.title || "");
		this.description = ko.observable(data.description || "");

		const props = data.properties || {};
		this.eventStart = ko.observable(props.eventStart ? new Date(props.eventStart) : null);
		this.eventEnd = ko.observable(props.eventEnd ? new Date(props.eventEnd) : null);
		this.registrationOpens = ko.observable(props.registrationOpens ? new Date(props.registrationOpens) : null);
		this.registrationCloses = ko.observable(props.registrationCloses ? new Date(props.registrationCloses) : null);
		this.childProducts = (data.bundleOptions || []).map(p => new Product(p));
		this.isSeries = ko.observable(props.isSeries || false);
		this.seriesPricing = ko.observable(props.seriesPricing || "");
		this.seriesDescriptor = ko.observable(props.seriesDescriptor || "");
		this.dayOfSeries = ko.observable(props.dayOfSeries || "");
		this.seriesIcon = ko.observable(props.seriesIcon || "");

		this.formattedPrice = ko.pureComputed(() => {
			const val = this.price() ?? 0;
			if (val <= 0)
				return 'Free';

			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: this.currency()
			}).format(val ?? 0);
		});

		this.eventDateDisplay = ko.pureComputed(() => {
			const start = this.eventStart();

			if (!(start instanceof Date) || isNaN(start)) {
				return "";
			}

			const dateFormatter = new Intl.DateTimeFormat('en-US', {
				month: 'long',
				day: 'numeric',
				year: 'numeric'
			});

			return dateFormatter.format(start);
		});
	}

	const viewModel = {
		product: ko.observable(new Product()),
		addToCart: function () {
			const key = viewModel.product().key();

			App.Commerce.Add(key, null, 1, {
				uuid: generateShortId(),
				cartDescription: "Recording and materials"
			});
		}
	};

	function getPurchaseProduct(productKey) {
		return $.ajax({
			url: `/api/products/${productKey}`,
			contentType: 'application/json; charset=utf-8',
			method: 'GET',
			dataType: 'json'
		}).fail(function (jqXHR) {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function generateShortId() {
		return Math.random().toString(36).substring(2, 9);
	}

    function init() {
		$(".offcanvas-registration.offcanvas-purchase").each(function () {
			ko.applyBindings(viewModel, this);

			$(this).on('show.bs.offcanvas', function (e) {
				var $trigger = $(e.relatedTarget);
				if (!$trigger || !$trigger.length)
					return;

				getPurchaseProduct($trigger.data("key") || "")
					.done(function (response) {
						if (!response) {
							App.Base.ShowError("API did not respond.");
							return;
						};

						if (response.success && response.data) {
							let purchaseProduct = response.data;
							viewModel.product(new Product(purchaseProduct));
							return;
						}
					});
			});
		});
    }

    return { init: init };
})(jQuery);

$(function () {
    App.PurchaseOffcanvas.init();
});